import type { Destination } from '@destinationsV2';

type MenuItem = {
  destination: Destination;
  title: string;
};

export const menu: MenuItem[] = [];
